import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';
import { CardData } from '../donut-card/donut-card.component';
import { slideInRight } from '../../../../helpers/slideIn';
import { CategoryData } from '../../../../models/category-data.model';

@Component({
  selector: 'lib-breakdown-dialog',
  standalone: false,
  templateUrl: './breakdown-dialog.component.html',
  styleUrl: './breakdown-dialog.component.scss',
  animations: [slideInRight]
})
export class BreakdownDialogComponent implements OnChanges {
  @Input() totalCount: number = 0;
  @Input() categories: CategoryData[] = [];
  @Input() breakdownData: CardData[] = [];
  @Input() mainTitle: string = '';
  
  @Output() closed = new EventEmitter<void>();

  isClosing = false;
  categoresFullNames: string[] = [];
  isNetworkStructure: boolean = false;
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categories']) {
      this.mapNetworkStructureCategoriesNames();
    }
  }
  
  private mapNetworkStructureCategoriesNames() {
    this.isNetworkStructure = false;
    this.categories.forEach((c, i) => {
      if (c.name == 'TS') {
        this.categoresFullNames[i] = 'Transmission Station';
        this.isNetworkStructure = true;
      }
      else if (c.name == 'INJ. SS') {
        this.categoresFullNames[i] = 'Injection Substation';
        this.isNetworkStructure = true;
      }
      else if (c.name == 'Distribution SS') {
        this.categoresFullNames[i] = 'Distribution Substation';
        this.isNetworkStructure = true;
      }
    })
  }

  close() {
    if (this.isClosing) return;
    this.isClosing = true;

    setTimeout(() => {
      this.closed.emit();
      this.isClosing = false;
    }, 150);
  }

  getCategoryShare(category: CategoryData): number {
    const total = this.categories.reduce((sum, cat) => sum + cat.count, 0);
    return total ? (category.count / total) * 100 : 0;
  }

  onBackdropClick(): void {
    this.close();
  }

  onCloseClick(): void {
    this.close();
  }
}
